//
//
//
//
//
//
//
export default {
  name: 'NoticeBar',
  data: function data() {
    return {
      show: true,
      timer: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('visibilitychange', this.visibilitychange, true);
  },
  mounted: function mounted() {
    this.show = !this.$Utils.appInfo;
  },
  methods: {
    // handleClose() {
    //   setLocalStorageKey('NOTICE_BAR_TIME', { times: Date.now(), num: 1 })
    //   this.show = false
    // },
    handleDownload: function handleDownload() {
      var _this = this;

      // this.$router.push({ name: 'DownloadGuide' })
      var browser = this.$Utils.isBrowser();

      if (browser.isMobile) {
        if (browser.isIos) {
          window.location.href = 'https://ubanquan.cn/app/';
        } else if (browser.isAndroid) {
          window.addEventListener('visibilitychange', this.visibilitychange, true);
          window.location.href = 'ucopyright://ucopyrightrouter/app';
          this.timer = setTimeout(function () {
            _this.$router.push({
              name: 'DownloadGuide'
            });
          }, 3000);
        } else {
          this.$router.push({
            name: 'DownloadGuide'
          });
        }
      } // window.location.href = 'intent://test-h5.ubanquan.cn#Intent;scheme=https;end'

    },
    visibilitychange: function visibilitychange() {
      if (document.hidden) {
        clearTimeout(this.timer);
      }
    }
  }
};